// if (!customElements.get("m-announcement-bar")) {
//   class MAnnouncementBar extends HTMLElement {
//     constructor() {
//       super();
//     }

//     connectedCallback() {
//       const enableSlider = this.dataset.enableSlider === "true";
//       if (!enableSlider) return;
//       this.initSlider();
//     }

//     initSlider() {
//       const autoplay = this.dataset.enableAutoplay === "true";
//       const autoplaySpeed = this.dataset.autoplaySpeed;
//       const slideContainer = this.querySelector(".swiper-container");
//       if (slideContainer) {
//         this.slider = new MinimogLibs.Swiper(slideContainer, {
//           slidesPerView:4,
//           slidesPerGroup:1,
//           autoplay: autoplay
//             ? {
//                 delay: parseInt(autoplaySpeed) * 1000,
//               }
//             : false,
//           loop: true,
//           navigation: {
//             nextEl: this.querySelector(".swiper-button-next"),
//             prevEl: this.querySelector(".swiper-button-prev"),
//           },
//         });
//       }
//     }
//   }

//   customElements.define("m-announcement-bar", MAnnouncementBar);
// }


if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;
      this.initSlider();
    }

    initSlider() {
      const autoplayEnabled = this.dataset.enableAutoplay === "true";
      const autoplaySpeedSec = parseInt(this.dataset.autoplaySpeed, 10) || 3;

      const slideContainer = this.querySelector(".swiper-container");
      if (!slideContainer) return;

      this.slider = new MinimogLibs.Swiper(slideContainer, {
        slidesPerView: 4,
        slidesPerGroup: 1,
        loop: true,
        breakpoints: {
          0: {      
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 8,
          },
          576: {        
            slidesPerView:1,
            slidesPerGroup: 1,
            spaceBetween: 16,
          },
          1024: {       
            slidesPerView:1,
            slidesPerGroup: 1,
            spaceBetween: 20,
          },
          1199: {       
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
          },
        },

        autoplay: autoplayEnabled
          ? { delay: autoplaySpeedSec * 1000, disableOnInteraction: false }
          : false,

        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },

        // Nice-to-haves for dynamic content
        observer: true,
        observeParents: true,
      });
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}